import IAction from "../../types/IAction";
import actionTypes from "../actionTypes";
import constants from "../../utils/constants";
import axios from "axios";

const MSCLUB_BASE_URL = "/api/clubs";

export const getConfiguracionesHorariosClubes = (): IAction => {
  return {
    type: actionTypes.GET_CONFIGURACIONES_HORARIOS_CLUBES,
    payload: axios.get(
      `${constants.BASE_URL}${MSCLUB_BASE_URL}/horarios-clubes/configuraciones`,
      {
        withCredentials: true,
        headers: {}
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getMantenimientos = (): IAction => {
  return {
    type: actionTypes.GET_MANTENIMIENTOS,
    payload: axios.get(
      `${constants.BASE_URL}${MSCLUB_BASE_URL}/horarios-clubes/mantenimientos`,
      {
        withCredentials: true,
        headers: {}
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const getClubes = (): IAction => {
  return {
    type: actionTypes.GET_CLUBES,
    payload: axios.get(
      `${constants.BASE_URL}${MSCLUB_BASE_URL}/horarios-clubes/clubes`,
      {
        withCredentials: true,
        headers: {}
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const crearConfiguracionesHorariosClubes = (data: any): IAction => {
  return {
    type: actionTypes.POST_CONFIGURACIONES_HORARIOS_CLUBES,
    payload: axios.post(
      `${constants.BASE_URL}${MSCLUB_BASE_URL}/horarios-clubes/configuraciones`,
      data,
      {
        withCredentials: true,
        headers: {}
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const actualizarConfiguracionesHorariosClubes = (
  id: string,
  data: any
): IAction => {
  return {
    type: actionTypes.PUT_CONFIGURACIONES_HORARIOS_CLUBES,
    payload: axios.put(
      `${constants.BASE_URL}${MSCLUB_BASE_URL}/horarios-clubes/${id}`,
      data,
      {
        withCredentials: true,
        headers: {}
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const eliminarConfiguracionesHorariosClubes = (id: string): IAction => {
  return {
    type: actionTypes.DELETE_CONFIGURACIONES_HORARIOS_CLUBES,
    payload: axios.delete(
      `${constants.BASE_URL}${MSCLUB_BASE_URL}/horarios-clubes/${id}`,
      {
        withCredentials: true,
        headers: {}
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};
